module.exports = __webpack_public_path__ + "img/loading.39d655a1.gif";